module.exports = {
  WarehouseNo: 'Số nhập kho',
  Warehouse: 'Tên kho hàng',
  WarehouseInDate: 'Thời gian nhập kho thực tế',
  State: 'Trạng thái nhập kho',
  PackageWarehouseInDate: 'Đóng gói - Thời gian nhập kho thực tế',
  PackageWarehouseOutDate: 'Đóng gói - Thời gian xuất kho thực tế',
  ReceiptNumber: 'Số biên nhận',
  ReceiptNo: 'Số phiếu biên nhận',
  PortOfDestination: 'Cảng đến',
  StorageDate: 'Thời gian nhập kho',
  DeliveryDate: 'Thời gian xuất kho',
  StorageDay: 'Ngày nhập kho',
  ActStorageDay: 'Ngày nhập kho thực tế',
  DeliveryDay: 'Ngày xuất kho',
  ActDeliveryDay: 'Ngày xuất kho thực tế',
  InputTime: 'Thời gian nhập liệu',
  DataEntryClerk: 'Người nhập liệu',
  NumberOfCases: 'Số kiện',
  Weight: 'Trọng lượng',
  Volume: 'Thể tích',
  ComputationIsAffectedByDampness: 'Hư hỏng/Ẩm ướt',
  IsNotComputationIsAffectedByDampness: 'Có bị hư hỏng/ẩm ướt không',
  ComputationIsAffectedByDampnessNum: 'Số kiện hư hỏng/ẩm ướt',
  IntoTheWarehousePhotos: 'Ảnh nhập kho',
  WarehouseName: 'Tên kho hàng',
  DeliveryMode: 'Phương thức xuất kho',
  Warehouseman: 'Nhân viên kho',
  WarehouseLocation: 'Vị trí kho',
  StorageLocation: 'Vị trí kho',
  TemperatureRequirement: 'Yêu cầu nhiệt độ',
  DeliveryCmp: 'Công ty giao hàng',
  IssueOrNot: 'Đã xuất kho chưa',
  PalletSum: 'Số lượng pallet',
  ReceiveDc: 'Đã nhận tài liệu chưa',
  LicensePlate: 'Biển số xe',
  DescriptionOfGoods: 'Mô tả hàng hóa',
  HandlingOpinions: 'Ý kiến xử lý',
  Remark: 'Ghi chú',
  SealingWeight: 'Trọng lượng niêm phong',
  Driver: 'Tài xế',
  DriverPhone: 'Số điện thoại tài xế',
  IsTheGoodsClosed: 'Có phải hàng niêm phong không',
  WarehouseInformation: 'Thông tin kho hàng',
  CargoDetails: 'Chi tiết hàng hóa',
  CargoPhotos: 'Ảnh hàng hóa',
  OperationRequirements: 'Yêu cầu thao tác',
  SelectFile: 'Chọn tệp',
  DeleteFile: 'Xóa tệp',
  AddCargo: 'Thêm hàng hóa',
  Detail: 'Chi tiết',
  Summary: 'Tổng hợp',
  FillData: 'Điền',
  maintenanceAllType: 'Số thùng hàng & Thông tin hàng hóa',
  maintenanceContainerNoType: 'Chỉ số thùng hàng',
  maintenanceWeightAndSizeType: 'Chỉ thông tin hàng hóa',
  DeleteCargo: 'Xóa hàng hóa',
  JobNumberInformation: 'Thông tin số công việc',
  Statistics: 'Thống kê',
  Number: 'Số phiếu',
  QuantityActual: 'Số kiện thực tế',
  WeightActual: 'Trọng lượng thực tế',
  CubageActual: 'Thể tích thực tế',
  WarehouseOutState: 'Trạng thái xuất kho',
  WarehouseInState: 'Trạng thái nhập kho',
  WarehouseIn: 'Nhập kho',
  WarehouseOut: 'Xuất kho',
  NewWarehouseFee: 'Thêm phí kho',
  WarehousePhotos: 'Ảnh kho hàng',
  StorageDayCanNotBeNull: 'Ngày nhập kho không được để trống.',
  DeliveryDayCanNotBeNull: 'Ngày xuất kho không được để trống.',
  WarehouseInSuccess: 'Đã nhập kho thành công.',
  WarehouseOutSuccess: 'Đã xuất kho thành công',
  NoChoiceWarehouseToBePrinted: 'Chưa chọn thông tin kho cần in!',
  PleaseSelectTheWarehousingNoticeToBeDeleted: 'Vui lòng chọn phiếu thông báo nhập kho cần xóa',
  WarehousingNotice: 'Phiếu thông báo nhập kho',
  AreYouSureToDeleteThisWarehousingNotice: 'Bạn có chắc chắn muốn xóa phiếu thông báo nhập kho này?',
  DeleteWarehousingNotice: 'Xóa phiếu thông báo nhập kho',
  ImportingData: 'Đang nhập dữ liệu',
  ThisOperationIsAnAsynchronousImport: 'Thao tác này là nhập dữ liệu không đồng bộ, bạn có thể xem kết quả nhập trong "Lưu trữ tệp -> Nhật ký tải lên"',
  ViewResults: 'Xem kết quả',
  BatchImportWarehousing: 'Nhập hàng loạt vào kho',
  BatchImportWarehousingData: 'Nhập dữ liệu nhập kho hàng loạt',
  NoWarehouseReceiptSelected: 'Chưa chọn phiếu nhập kho',
  Checklist: 'Kiểm tra phiếu',
  ReturnGoods: 'Trả hàng',
  OnlySave: 'Chỉ lưu',
  Save: 'Lưu',
  SaveAndWeigh: 'Lưu và cân',
  SaveAndChecklist: 'Lưu và kiểm tra phiếu',
  WeighAndChecklist: 'Cân và kiểm tra phiếu',
  PoOriginalOrderNo: 'PO (Số đơn gốc)',
  ServiceChannel: 'Kênh dịch vụ',
  DestinationDeliveryMethod: 'Phương thức giao hàng đến đích',
  OverseasWarehouse: 'Kho nước ngoài',
  DestinationCountry: 'Quốc gia đích',
  Weigh: 'Cân',
  ReceivingWarehouse: 'Kho nhận hàng',
  CommissionNo: 'Số ủy thác',
  OverseasWarehouseCode: 'Mã kho nước ngoài',
  RemoteWarehouse: 'Kho xa',
  boxLengthPlaceholder: 'Dài',
  boxWidthPlaceholder: 'Chiều rộng',
  BoxHeightPlaceholder: 'Chiều cao',
  SizeNotZero: 'Chiều dài, chiều rộng, chiều cao, số kiện không thể nhỏ hơn hoặc bằng 0',
  EstEnteringAmazonWarehouse: 'Thời gian dự kiến nhập kho Amazon',
  ChargingMethod: 'Phương thức tính phí',
  Total: 'Tổng',
  WeighTime: 'Thời gian cân',
  weighCheckMsg: 'Thông tin nhập kho này đã {0}, không thể cân',
  ChecklistTime: 'Thời gian kiểm tra đơn',
  ReturnGoodsTime: 'Thời gian trả hàng',
  CourierServicesCompany: 'Công ty chuyển phát',
  Electric: 'Có pin hay không',
  Magnetic: 'Có từ tính hay không',
  Powdery: 'Có phải là bột hay không',
  Liquid: 'Có phải là chất lỏng hay không',
  BatchMaintenance: 'Bảo trì hàng loạt',
  PickingGoods: 'Nhặt hàng theo dữ liệu khách hàng',
  AdjustChargeWeight: 'Điều chỉnh trọng lượng tính phí',
  ContainerNo: 'Số thùng hàng',
  BoxesNumber: 'Số thùng',
  SingleBoxWeight: 'Trọng lượng thùng hàng đơn (KG)',
  DialogSingleBoxWeight: 'Trọng lượng thùng hàng đơn (KG)',
  BoxLength: 'Chiều dài thùng hàng (CM)',
  BoxWidth: 'Chiều rộng thùng hàng (CM)',
  BoxHeight: 'Chiều cao thùng hàng (CM)',
  UnitRate: 'Giá khai báo (sản phẩm đơn lẻ)',
  Quantity: 'Số lượng khai báo (thùng đơn)',
  BoxSize: 'Kích thước thùng đơn',
  HsCode: 'Mã hải quan',
  Brand: 'Thương hiệu',
  BrandType: 'Loại thương hiệu',
  ModelNo: 'Model',
  MaterialQuality: 'Chất liệu',
  Purpose: 'Công dụng',
  SalesLink: 'Liên kết bán hàng',
  SalesPrice: 'Giá bán',
  PictureUrl: 'Hình ảnh',
  WeightKg: 'Trọng lượng (KG)',
  CargoType: 'Loại hàng hóa',
  ProductDescription: 'Mô tả sản phẩm',
  CheckWeighTime: 'Thông tin nhập kho này đã được cân, có cập nhật dữ liệu cân không?',
  ChecklistTimeTip: 'Thời gian kiểm tra đơn [{0}] không được nhỏ hơn thời gian cân [{1}], vui lòng kiểm tra.',
  ReturnReason: 'Lý do trả hàng',
  ReturnGoodsTips: 'Bao gồm dữ liệu {0}, vui lòng xác nhận có trả hàng không?',
  ChecklistResult: 'Kết quả kiểm tra đơn',
  ModifiedReason: 'Lý do sửa đơn',
  WsTjRemark: 'Giải thích sửa đơn',
  WsTjReason: 'Lý do xóa đơn',
  WsTjDelRemark: 'Giải thích xóa đơn',
  ModifiedWsTjTips: 'Cần bổ sung giải thích nếu có lý do khác',
  FaceOrderPrintTime: 'Thời gian in phiếu gửi chuyển phát',
  CourierNumber: 'Số vận đơn',
  RefContainerNo: 'Số tham chiếu thùng',
  isWeigh: 'Đã cân chưa?',
  isChecklist: 'Đã kiểm tra đơn chưa?',
  isReturn: 'Đã trả lại chưa?',
  ChecklistTip: 'Dữ liệu đã chọn có chứa dữ liệu chưa cân, vui lòng kiểm tra.',
  cannotEditOutData: 'Dữ liệu đã xuất kho không thể chỉnh sửa',
  alreadyChecklist: 'Đơn hàng này đã được kiểm tra, vui lòng kiểm tra.',
  delChecklistData: 'Chứa dữ liệu đã kiểm tra, không thể xóa.',
  repeatPackingData: 'Chứa dữ liệu đã đóng thùng, không thể đóng thùng lặp lại, vui lòng kiểm tra.',
  ChecklistTipOne: 'Dữ liệu đã chọn có chứa dữ liệu chưa cân, có kiểm tra đơn không?',
  RegistrationSlip: 'Đăng ký mặt hàng',
  ContainerNoEditor: 'Chỉnh sửa số thùng hàng',
  PerContainerNo: 'Tiền tố số thùng (Mã FBA):',
  boxNum: 'Số thùng:',
  boxSeq: 'Số thứ tự thùng:',
  boxSeqType3: 'Độ dài 3 ký tự',
  boxSeqType6: 'Độ dài 6 ký tự',
  boxSeqTooLong: 'Số thứ tự thùng vượt quá giá trị tối đa [{0}], vui lòng kiểm tra',
  duplicateContainerNo: 'Số thùng hàng [{0}] đã tồn tại, vui lòng nhập lại',
  shipmentIdNotNull: 'Vui lòng nhập shipment Id trước!',
  boxesNumberNotNull: 'Vui lòng nhập số thùng trước!',
  cargoChineseNameNotNull: 'Vui lòng nhập tên hàng hóa bằng tiếng Trung trước!',
  cargoEnglishNameNotNull: 'Vui lòng nhập tên hàng hóa bằng tiếng Anh trước!',
  singleBoxWeightNotNull: 'Vui lòng nhập trọng lượng thùng hàng trước!',
  boxesSizeNotNull: 'Vui lòng nhập kích thước thùng hàng trước!',
  boxSeqNotNull: 'Vui lòng nhập số thứ tự thùng trước',
  deleteTheDetailRecord: 'Tất cả chi tiết trong danh sách hiện tại sẽ bị xóa, có tiếp tục không?',
  overwriteTheDetailRecord: 'Tất cả chi tiết trong danh sách hiện tại sẽ bị ghi đè bằng dữ liệu khách hàng, có tiếp tục không?',
  overwriteTheDetailRecordByJobRelated: 'Tất cả chi tiết trong danh sách hiện tại sẽ bị ghi đè bằng dữ liệu khách hàng, có tiếp tục không?',
  continuePicking: 'Chưa kiểm tra đơn, có tiếp tục đóng thùng không?',
  continueReturnGoods: 'Sau khi trả lại sẽ không xử lý các thao tác như ghép container, có tiếp tục không?',
  editShipmentId: 'Số thùng hàng không khớp với ShipmentId, có làm mới số thùng hàng không?',
  editActJmt: 'Chi tiết thùng hàng đã có giá trị, không được phép sửa thông tin tổng hợp trọng lượng!',
  storageAgeEdit: 'Điều chỉnh tuổi kho',
  storageAgeEditDay: 'Ngày (tự động/tính thực tế)',
  storageAgeEditWeek: 'Tuần (tự động/tính thực tế)',
  Packing: 'Đóng thùng',
  ExWarehouse: 'Xuất kho',
  weightOpCannotChecklist: 'Không được phép lưu, nếu cần kiểm tra đơn, vui lòng nhấn nút [Cân và kiểm tra đơn].',
  saveCheckContainerNoFail: 'Chi tiết có dữ liệu chưa nhập số thùng hàng, vui lòng kiểm tra!',
  saveCheckShipmentIdFail: 'Chi tiết có dữ liệu chưa nhập Shipment Id, vui lòng kiểm tra!',
  saveCheckQuantityFail: 'Chi tiết có dữ liệu chưa nhập trọng lượng thùng hàng, vui lòng kiểm tra!',
  saveCheckBoxLengthFail: 'Chi tiết có dữ liệu chưa nhập chiều dài thùng hàng, vui lòng kiểm tra!',
  saveCheckBoxWidthFail: 'Chi tiết có dữ liệu chưa nhập chiều rộng thùng hàng, vui lòng kiểm tra!',
  saveCheckBoxHeightFail: 'Chi tiết có dữ liệu chưa nhập chiều cao thùng hàng, vui lòng kiểm tra!',
  saveCheckChineseCargoNameFail: 'Chi tiết có dữ liệu chưa nhập tên hàng hóa bằng tiếng Trung, vui lòng kiểm tra!',
  saveCheckEnglishCargoNameFail: 'Chi tiết có dữ liệu chưa nhập tên hàng hóa bằng tiếng Anh, vui lòng kiểm tra!',
  saveCheckBrandFail: 'Chi tiết có dữ liệu chưa nhập thương hiệu, vui lòng kiểm tra!',
  saveCheckBrandTypeFail: 'Chi tiết có dữ liệu chưa nhập loại thương hiệu, vui lòng kiểm tra!',
  FaceListCheckExpressDelivery: 'Phương thức giao hàng tại điểm đến không phải là chuyển phát nhanh, không cần đăng ký phiếu gửi hàng',
  FaceListCheckTip: 'Không có thông tin cân nặng, có tiếp tục đăng ký thông tin phiếu gửi hàng chuyển phát nhanh không?',
  PackingTipOne: 'Bao gồm dữ liệu hàng đã trả lại, không thể đóng thùng, vui lòng kiểm tra.',
  PackingTipTwo: 'Dữ liệu đã chọn bao gồm dữ liệu chưa được duyệt, có tiếp tục đóng thùng không?',
  ExWarehouseTip: 'Dữ liệu đã chọn bao gồm dữ liệu đã xuất kho, vui lòng kiểm tra',
  LabelingTime: 'Thời gian dán nhãn',
  Labeling: 'Dán nhãn',
  Pallet: 'Có đóng pallet không?',
  PalletNo: 'Số hiệu pallet',
  DaycareInformation: 'Thông tin đóng pallet',
  PreDeliveryTime: 'Ngày giao hàng dự kiến',
  ActDeliveryTime: 'Ngày giao hàng thực tế',
  LogisticsNo: 'Số vận đơn',
  OperationStatus: 'Trạng thái thao tác kho nước ngoài',
  LogisticsNoEnd: 'Số vận đơn (chặng cuối)',
  palletContainerNum: 'Số thùng đã đóng pallet',
  otherContainerNum: 'Số thùng lẻ',
  updateIssueRemarks: 'Ghi chú xuất kho',
  DateOfService: 'Ngày giao hàng',
  onWarehouseInCheck: 'Dữ liệu đã chọn bao gồm dữ liệu không ở trạng thái chờ nhập kho, vui lòng kiểm tra',
  PleaseChooseADataEntry: 'Vui lòng chọn một dữ liệu!',
  ExternallyImportedDataCannotEdit: 'Dữ liệu nhập từ bên ngoài, không thể chỉnh sửa.',
  CannotEditExternalData: 'Dữ liệu nhập từ bên ngoài, không thể chỉnh sửa.',
  PleaseChooseDesignatedData: 'Vui lòng chọn dữ liệu chỉ định',
  CargoWareDoorstepVehicleDrivingButton: 'CargoWare - Chức năng nghiệp vụ - Điểm giao nhận khách hàng - Lộ trình xe (nhấn nút)',
  PlateOrderNumberCannotEmpty: 'Biển số xe và số vận đơn không được để trống',
  NoAvailableAtThisTime: 'Hiện chưa có thông tin liên quan'
}
